import { useEffect, useRef, useState } from "react";
import TextInput, { Formatters } from "../../gui/TextInput/TextInput";
import { TUnit } from "../../shared/Recipes";
import { UpdateEvent } from "../../gui/GUIEvents";
import Dropdown from "../../gui/Dropdown/Dropdown";
import { UnitOptions } from "../../data/RecipeCache";
import IconButton from "../../gui/Button/IconButton";
import SettingsIcon from "../../gui/Icons/SettingsIcon";
import { useUnitSettings } from "./UnitSettingsDlg";
import { IFood } from "../../shared/IFood";
import Foods from "../../data/Foods";

export type TFactsheetToolbarPoprs = {
    food:IFood
    onUpdateFactor:(factor:number) => void
}
export default function FactsheetToolbar(props:TFactsheetToolbarPoprs){
    const [amount,setAmount] = useState<string>("100")
    const [unit,setUnit] = useState<TUnit>("g")
    const {showUnitSettings} = useUnitSettings()
    const mounted = useRef<boolean>(false)
    const notify = (amount:number,unit:TUnit) => props.onUpdateFactor(Foods.amountInGrams(props.food, amount, unit)/100)
    const onAmount = (e:UpdateEvent<string>) => { 
        const value = e.value ?? "100"
        setAmount(value)
        notify(parseFloat(value), unit)
    }
    const onUnit = (e:UpdateEvent<string>) => {
        const value = e.value ? e.value as TUnit : "g"
        setUnit(value)
        notify(parseFloat(amount), value)
    }
    const onUnitSettings = () => showUnitSettings(props.food)
    useEffect(() => {
        console.log("update food", props.food, Foods.amountInGrams(props.food, parseFloat(amount), unit)/100)
        if (mounted.current) notify(parseFloat(amount), unit)
        else mounted.current = true        
    }, [props.food])
    return <div className="toolbar flex middle gap-16">
        <TextInput formatter={Formatters.PositiveRealNumber} value={amount} onUpdate={onAmount} placeholder="Amount"/>
        <Dropdown className="unit" options={UnitOptions} value={unit} onUpdate={onUnit} hideArrow={true} anchorProps={{width:"match"}}/>
        <IconButton onClick={onUnitSettings}><SettingsIcon/></IconButton>
    </div>
}